import React from "react";
import {UserWithStats} from "../../models/UserWithStats";
import {useNavigate} from "react-router";
import {UiFlag} from "../ui-components/flag/UiFlag";
import {getRelativeTime} from "../../utils";
import {useTranslation} from "react-i18next";

type position = 1 | 2 | 3;

type Top3PlayerCardType = {
    className?: string,
    user: UserWithStats,
    position: position
}

export const Top3PlayerCard: React.FC<Top3PlayerCardType> = (props) => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    
    function getShadowColor() {
        switch (props.position) {
            case 1:
                return "shadow-gold-first";
            case 2:
                return "shadow-silver-second";
            case 3:
                return "shadow-bronze-third";
        }
    }
    
    return (
        <div
            className={"flex flex-col text-center cursor-pointer items-center w-full xl:w-96 "
                + (props.className ? props.className : "")}
            onClick={() => navigate(`/stats?player-id=${props.user.id}`)}
        >
            <div className={`w-36 h-36 md:w-48 md:h-48 xl:w-56 xl:h-56 shadow-podium ${getShadowColor()} rounded-full`}>
                <img
                    className="w-full h-full rounded-full"
                    src={props.user.getPP()}
                    alt={`${props.user.name} profile picture`}
                />
            </div>

            <div className="flex w-full gap-4 items-center justify-center py-2 ">
                <p className="text-3xl text-wrap break-all">{props.user.name}</p>
                {props.user.country && <UiFlag className="min-w-8 h-5" countryCode={props.user.country}/>}
            </div>
            <p className="text-2xl">{t("stats.score-x", {score: props.user.best})}</p>
            <p className="text-text-transparent text-sm">{getRelativeTime(t, props.user.dateBest)}</p>
        </div>
    )
}
